import * as apiCommon from '@/api/apiCommon'

// 部门介绍
const apiName = '/webapi/department'

// 获取
export function index(data) {
	return apiCommon.index(apiName + '/index', data)
}